module.exports = __webpack_public_path__ + "static/media/general_rules_of_accent_img.4994204b.JPG";